module.exports = __webpack_public_path__ + "media/assets/images/blog/fixing_board-small-0c9e28a93768f69772b31947e9aea8fc.jpeg";